/**
 * This page is only ever reached via `GET /display/:outputId`'s redirect
 * (`packages/local-server`'s `display.route.ts`), which always targets
 * this app's dev server on the *same host* the browser used to reach the
 * sidecar — only the port differs (sidecar `47311` vs. this app's own
 * `5173`, `vite.config.ts`). So the sidecar's own address is derived from
 * `window.location.hostname` rather than hardcoded to `127.0.0.1` —
 * correct whether this page was reached via `localhost` or a real LAN IP.
 */
const SIDECAR_PORT = 47_311;

export function sidecarHost(): string {
  return window.location.hostname;
}

export function sidecarBaseUrl(): string {
  return `http://${sidecarHost()}:${SIDECAR_PORT}`;
}

export function sidecarWsUrl(): string {
  return `ws://${sidecarHost()}:${SIDECAR_PORT}/ws`;
}
